// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__3_Wwf","element":"Loader_element__3yE1w","EagfyoDq_draw":"Loader_EagfyoDq_draw__Aqgvj"};